/**
 * Tutorial Registry
 *
 * Central list of all available tutorials.
 * Import and register new tutorials here.
 */

import type { TutorialDefinition } from './types'
import { pwaInstallTutorial } from './pwa-install'
import { attendanceTutorial } from './attendance'
import { participantsTutorial } from './participants'
import { billingTutorial } from './billing'
import { guestsTutorial } from './guests'
import { offlineTutorial } from './offline'

/**
 * All registered tutorials, ordered by display priority.
 *
 * Reihenfolge nach dem Weg durch die App: erst installieren, dann die tägliche
 * Arbeit (Anwesenheit, Gäste), dann Nachschlagen (Teilnehmer), dann das, was
 * einmal im Monat ansteht (Abrechnung). Der Offline-Hinweis steht am Ende, weil
 * er kein eigener Arbeitsschritt ist, sondern die anderen begleitet.
 */
export const tutorials: readonly TutorialDefinition[] = [
  pwaInstallTutorial,
  attendanceTutorial,
  guestsTutorial,
  participantsTutorial,
  billingTutorial,
  offlineTutorial,
]
